document.addEventListener("DOMContentLoaded", function () {

  function attachHoverListeners(card) { ///FUNZIONE GESTIONE BACK IMAGE

    if (!card.hasAttribute('data-listeners-attached')) {
      var productImageElement = card.querySelector(".card__media img");
      card.addEventListener('mouseover', function () {
        // Legge l'immagine retro aggiornata dai dataset
        const backImage = productImageElement.dataset.backImage;
        if (backImage) {
          productImageElement.src = backImage;
          productImageElement.srcset = [
            `${backImage}?width=165 165w`,
            `${backImage}?width=360 360w`,
            `${backImage}?width=533 533w`,
            `${backImage}?width=720 720w`,
            `${backImage}?width=940 940w`,
            `${backImage}?width=1066 1066w`,
          ].join(", ");
        }
      });
      card.addEventListener('mouseout', function () {
        // Ripristina l'immagine frontale aggiornata dai dataset
        const frontImage = productImageElement.dataset.frontImage;
        if (frontImage) {
          productImageElement.src = frontImage;
          productImageElement.srcset = [
            `${frontImage}?width=165 165w`,
            `${frontImage}?width=360 360w`,
            `${frontImage}?width=533 533w`,
            `${frontImage}?width=720 720w`,
            `${frontImage}?width=940 940w`,
            `${frontImage}?width=1066 1066w`,
          ].join(", ");
        }
      });
      // Segna l'elemento come già "attaccato"
      card.setAttribute('data-listeners-attached', 'true');
    }

  }


  function updateProductImage(card, variantData, variantId) {
    var productImageElement = card.querySelector(".card__media img");
    // Imposta l'immagine frontale della variante corrente
    var frontImage = variantData.imageUrl;
    // Imposta l'immagine retro (se disponibile) per la variante corrente
    var backImage = variantData.imageBackUrl;
    // Aggiorna i dataset dell'immagine con i nuovi valori
    productImageElement.dataset.frontImage = frontImage;
    productImageElement.dataset.backImage = backImage;
    //attachHoverListeners(card, productImageElement);

    if (productImageElement) {

      var lazyLoadAllVariants =
        card.getAttribute("data-lazy-load-all-variants") === "true";
      if (productImageElement) {
        // Recupera l'immagine retro dal metafield
        const variantId = card.getAttribute("data-variant-id");

        const variantData =
          window[
          `variantDataMap${card
            .getAttribute("data-section-id")
            .replace(/-/g, "_")}_${card.getAttribute("data-product-id")}`
          ];

      }

      if (lazyLoadAllVariants) {
        var preloadedImage = card.querySelector(
          `img[data-variant-id="${variantId}"]`
        );
        if (preloadedImage) {
          productImageElement.src = preloadedImage.src;
          productImageElement.srcset = preloadedImage.srcset;
        }
      } else if (variantData && variantData.imageUrl) {
        var dynamicSrcset = [
          `${variantData.imageUrl}?width=165 165w`,
          `${variantData.imageUrl}?width=360 360w`,
          `${variantData.imageUrl}?width=533 533w`,
          `${variantData.imageUrl}?width=720 720w`,
          `${variantData.imageUrl}?width=940 940w`,
          `${variantData.imageUrl}?width=1066 1066w`,
        ].join(", ");
        productImageElement.srcset = dynamicSrcset;
        productImageElement.src = variantData.imageUrl;
      }
      attachHoverListeners(card);

    }
  }


  function updateProductLinks(card, variantData) {
    var productLinks = card.querySelectorAll(
      'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
    );
    productLinks.forEach(function (link) {
      link.href = variantData.productUrl;
    });

    var quickAddButton = card.querySelector(".quick-add__submit");
    if (quickAddButton) {
      quickAddButton.setAttribute("data-product-url", variantData.productUrl);
    }
  }

  function storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem(
      "selectedVariant-" + sectionId + "-" + productId,
      variantId
    );
  }

  function storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem(
      "selectedSwatch-" + sectionId + "-" + productId,
      variantId
    );
  }

  function restoreSelectedVariant(
    productGrid,
    sectionId,
    productId,
    variantDataMap
  ) {
    var selectedVariantId = sessionStorage.getItem(
      "selectedVariant-" + sectionId + "-" + productId
    );
    if (selectedVariantId && variantDataMap[selectedVariantId]) {
      var card = productGrid.querySelector(
        `.card-product-custom-div[data-section-id="${sectionId}"][data-product-id="${productId}"]`
      );
      var variantData = variantDataMap[selectedVariantId];
      updateProductImage(card, variantData, selectedVariantId);
      updateProductLinks(card, variantData);
    }
  }

  function restoreSelectedSwatch(productGrid, sectionId, productId) {
    var selectedVariantId = sessionStorage.getItem(
      "selectedSwatch-" + sectionId + "-" + productId
    );
    if (selectedVariantId) {
      var swatchInput = productGrid.querySelector(
        `input[type="radio"][data-variant-id="${selectedVariantId}"][data-section-id="${sectionId}"]`
      );
      if (swatchInput) {
        swatchInput.checked = true;
      }
    }
  }

  function initializeProductGrid(productGrid) {
    var sectionId = productGrid.getAttribute("data-id");
    productGrid
      .querySelectorAll(".card-product-custom-div")
      .forEach(function (card) {
        var productId = card.getAttribute("data-product-id");
        var variantDataMap =
          window[
          "variantDataMap" + sectionId.replace(/-/g, "_") + "_" + productId
          ];
            // Aggiungi un controllo per evitare l'errore
    if (!variantDataMap) {
      console.warn("Nessun variantDataMap trovato per il prodotto " + productId);
      return; // oppure puoi usare continue se stai iterando su una lista
    }
        
        var defaultVariantId = card.getAttribute("data-variant-id") || Object.keys(variantDataMap)[0];
        var defaultVariantData = variantDataMap[defaultVariantId];
        card.setAttribute("data-variant-id", defaultVariantId);
        

        restoreSelectedVariant(
          productGrid,
          sectionId,
          productId,
          variantDataMap
        );

        updateProductImage(card, defaultVariantData, defaultVariantId);
        updateProductLinks(card, defaultVariantData);
        restoreSelectedSwatch(productGrid, sectionId, productId);

        card.addEventListener("change", function (e) {
          if (
            e.target.matches(
              'input[type="radio"][data-section-id="' + sectionId + '"]'
            )
          ) {
            var variantId = e.target.getAttribute("data-variant-id");
            var variantData = variantDataMap[variantId];
            if (!variantData) {
              return;
            }
            storeSelectedVariant(sectionId, productId, variantId);
            storeSelectedSwatch(sectionId, productId, variantId);
            updateProductImage(card, variantData, variantId);
            updateProductLinks(card, variantData);
          }
        });
        card.classList.add("loaded");
      });
  }

  function initializeAllProductGrids() {
    var productGrids = document.querySelectorAll(".grid.product-grid");
    productGrids.forEach(initializeProductGrid);
  }

  initializeAllProductGrids();


  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        initializeAllProductGrids();
      }
    });
  });

  var config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});